<template>
  <div class="app">
    <!-- conteúdo geral -->
    <Header v-if="!loading && isLogged" />
    <Content v-if="!loading && isLogged" />
    <!-- <Footer /> -->
    <offline @detected-condition="handleNetworkChange" />
    <div v-if="!loading && isLogged && !online" class="connection-status">
      <p>A Aplicação Está Sem Acesso a internet !!!</p>
    </div>
    <!-- fim -->
    <!-- página de login-->
    <Login class="application-login" v-if="!loading && !isLogged" />
    <!-- carregamento da tela-->
    <!-- Carregamento-->
    <div v-if="loading" class="application-center-load-login">
      <img src="@/assets/save-form.gif" alt="Carregando" />
    </div>
  </div>
</template>

<script>
//mapeamento de objetos gerais
import { mapState } from "vuex";
import { baseApiUrl } from "@/global";
//cliente http
import axios from "axios";
//eventos
import { EventBusLogged } from "@/eventBus/eventBusLogged";
//componentes
import Header from "@/components/template/Header";
import Content from "@/components/template/Content";
// import Footer from "@/components/template/Footer";
import Login from "@/components/auth/Login";
//status connect
import offline from "v-offline";

export default {
  name: "App",
  computed: mapState(["isLogged"]),
  components: { Header, Content, Login, offline },
  data() {
    return {
      loading: true,
      online: false
    };
  },
  methods: {
    async logged() {
      this.loading = true;
      const token = sessionStorage.getItem("token");
      const user = sessionStorage.getItem("user");
      this.$store.commit("ADD_ISLOGGED", false);
      if (token && user) {
        axios
          .post(`${baseApiUrl}/checkLogged`, { login: user, token: token })
          .then(resp => {
            if (!resp.data.error) {
              this.$store.commit("ADD_USER_CONTEXT", resp.data.userContext);
              this.$store.commit("ADD_ISLOGGED", true);
            }
            this.loading = false;
          });
      } else {
        this.$router.push({ name: "home" });
        this.loading = false;
      }
    },
    handleNetworkChange(status) {
      this.online = status;
    }
  },
  mounted() {
    this.logged();
    //evento de recarregar informações do usuário logado
    EventBusLogged.$on("refreshLogged", () => {
      this.logged();
    });
  }
};
</script>


<style>
* {
  font-family: "Lato", sans-serif;
}

body {
  margin: 0;
  max-width: 100%;
  overflow-x: hidden;
}

.app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: grid;
  grid-template-rows: 60px 1fr 40px;
  grid-template-columns: 300px 1fr;
  grid-template-areas:
    "header header"
    "content content";
}

.application-center-load-login {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.application-login {
  position: absolute;
  width: 60%;
  height: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.toast-global {
  font-weight: bold;
  font-size: 18px !important;
}

.connection-status {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 7%;
  width: 100%;
  background: #c15959;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.connection-status > p {
  font-weight: bold;
  font-size: 18px;
  margin-top: 12px;
}

/* área responsiva */
@media screen and (max-width: 600px) {
  .application-login {
    width: 90%;
    top: 43%;
  }
}
</style>